import animationManager, {
  AnimationEndsCallbacks,
  AnimationStatusCallbacks,
  makeSequence,
  SequenceStep
} from '../../services/animations/animation-manager';
import { AnimationSequences, AnimationSequencesType } from '../../utility/constants';

export const registerOpenSingleDrawerAnimation = ({
  onAnimationStarts,
  onAnimationEnds
}: Required<AnimationStatusCallbacks>): void => {
  const sequence: SequenceStep[] = [
    [
      {
        onStart: onAnimationStarts,
        elementSelector: 'phn-single-drawer',
        animation: {
          className: 'slide-in-from-left',
          cleanUpAfterAnimation: (element) => {
            element.style.left = '0px';
          }
        }
      },
      {
        elementSelector: 'phn-backdrop',
        animation: {
          className: 'fade-in-animation',
          cleanUpAfterAnimation: (element) => {
            element.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
            element.style.opacity = '1';
          }
        },
        onEnd: onAnimationEnds
      }
    ]
  ];

  animationManager.register(AnimationSequences.OPEN_SINGLE_DRAWER, makeSequence(sequence));
};

export const registerCloseSingleDrawerAnimation = ({
  onAnimationStarts,
  onAnimationEnds
}: Required<AnimationStatusCallbacks>): void => {
  const sequence: SequenceStep[] = [
    [
      {
        onStart: onAnimationStarts,
        elementSelector: 'phn-single-drawer',
        animation: {
          className: 'slide-out-to-left',
          cleanUpBeforeAnimation: (element) => {
            element.style.left = '';
          },
          cleanUpAfterAnimation: (element) => {
            element.style.left = '-1000px';
          }
        }
      },
      {
        elementSelector: 'phn-backdrop',
        animation: {
          className: 'fade-out-animation',
          cleanUpBeforeAnimation: (element) => {
            element.style.backgroundColor = '';
            element.style.opacity = '';
          }
        },
        onEnd: onAnimationEnds
      }
    ]
  ];

  animationManager.register(AnimationSequences.CLOSE_SINGLE_DRAWER, makeSequence(sequence));
};

export const registerTransitionNextLevelSingleDrawerAnimation = ({ onAnimationEnds }: AnimationEndsCallbacks): void => {
  animationManager.register(
    AnimationSequences.TRANSITION_NEXT_LEVEL_SINGLE_DRAWER,
    makeSequence([
      [
        {
          elementSelector: 'phn-single-drawer .drawer.animating',
          animation: {
            className: 'slide-in-from-right-fixed'
          },
          onEnd: onAnimationEnds
        }
      ]
    ])
  );
};

export const registerTransitionPreviousLevelSingleDrawerAnimation = ({
  onAnimationEnds
}: AnimationEndsCallbacks): void => {
  animationManager.register(
    AnimationSequences.TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER,
    makeSequence([
      [
        {
          elementSelector: 'phn-single-drawer .drawer.animating',
          animation: {
            className: 'slide-out-to-right-fixed'
          },
          onEnd: onAnimationEnds
        }
      ]
    ])
  );
};

export const isPlayingSingleDrawerAnimation = (): boolean => {
  try {
    const singleDrawerAnimationSequences: AnimationSequencesType[] = [
      AnimationSequences.OPEN_SINGLE_DRAWER,
      AnimationSequences.CLOSE_SINGLE_DRAWER,
      AnimationSequences.TRANSITION_NEXT_LEVEL_SINGLE_DRAWER,
      AnimationSequences.TRANSITION_PREVIOUS_LEVEL_SINGLE_DRAWER
    ];

    return singleDrawerAnimationSequences.some((sequence) => {
      try {
        return animationManager.isPlaying(sequence);
      } catch {
        return false;
      }
    });
  } catch (e) {
    return false;
  }
};
